import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import EventDetailsViewer from "./EventDetailsViewer"

const Accordion = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
  root: {
    backgroundColor: 'rgba(0, 0, 0, .03)',
    borderBottom: '1px solid rgba(0, 0, 0, .125)',
    marginBottom: -1,
    minHeight: 56,
    '&$expanded': {
      minHeight: 56,
    },
  },
  content: {
    '&$expanded': {
      margin: '12px 0',
    },
  },
  expanded: {},
})(MuiAccordionSummary);

const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiAccordionDetails);

const CloudwatchLogDetailsTab = ({ items }: any): any => {

  const [expanded, setExpanded] = React.useState<string | false>('panel0');

  const handleChange = (panel: string) => (event: React.ChangeEvent<any>, newExpanded: boolean) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      {items && items.map((item: any, id: number) => {
        const panelId = `panel${id}`
        const logDetails = JSON.stringify(item.message)
        return (
          <Accordion key={id} square expanded={expanded === panelId} onChange={handleChange(panelId)}>
            <AccordionSummary aria-controls="panel1d-content" id={panelId}>
              <span>Log timestamp: {item.timestamp}</span>
            </AccordionSummary>
            <AccordionDetails >
              <EventDetailsViewer eventDetail={logDetails} />
            </AccordionDetails>
          </Accordion>
        )
      })
      }
    </div>
  );
}

export default CloudwatchLogDetailsTab;